const config = {
  apiBaseUrl: 'https://api.stlt.io'
}

export default config
